import { Box } from "@mui/material";
import {
  FEATURED_BADGE_COLOR,
  INDUSTRY_COLORS,
  PARTNER_TYPE_COLORS,
  type IndustryType,
  type PartnerType,
} from "types/partners";

interface PartnerBadgeProps {
  type: "partner" | "industry" | "featured";
  value: PartnerType | IndustryType | "featured";
  label?: string;
  size?: "small" | "medium";
}

const DEFAULT_BADGE_COLOR = { background: "#E0E0E0", text: "#333333" };

export default function PartnerBadge({
  type,
  value,
  label,
  size = "small",
}: PartnerBadgeProps) {
  let colors;

  if (type === "featured") {
    colors = FEATURED_BADGE_COLOR;
  } else if (type === "partner") {
    colors = PARTNER_TYPE_COLORS[value as PartnerType] || DEFAULT_BADGE_COLOR;
  } else {
    colors = INDUSTRY_COLORS[value as IndustryType] || DEFAULT_BADGE_COLOR;
  }

  const isFeatured = type === "featured";

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 1,
        minWidth: 0,
        width: "100%",
        px: isFeatured
          ? {
              xs: 1,
              sm: 1.5,
            }
          : size === "small"
            ? {
                xs: 0.5,
                sm: 1,
              }
            : 2,
        py: isFeatured
          ? 0.25
          : size === "small"
            ? {
                xs: 0.25,
                sm: 0.5,
              }
            : 0.75,
        borderRadius: isFeatured ? "8px" : "9999px",
        backgroundColor: colors.background,
        color: colors.text,
        fontSize: isFeatured
          ? {
              xs: "0.6rem",
              sm: "0.7rem",
              md: "0.65rem",
              lg: "0.65rem",
              xl: "0.65rem",
            }
          : size === "small"
            ? {
                xs: "0.6rem",
                sm: "0.8125rem",
                md: "0.75rem",
                lg: "0.75rem",
                xl: "0.75rem",
              }
            : {
                xs: "1.0625rem",
                sm: "1rem",
                md: "0.9375rem",
                lg: "0.9375rem",
                xl: "0.9375rem",
              },
        fontWeight: 600,
        lineHeight: 1.1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {label || value}
    </Box>
  );
}
